export default "__VITE_ASSET__BUg6pNsf__"